import { render, staticRenderFns } from "./Ihbarname891HacizForm.vue?vue&type=template&id=0b1098d8&scoped=true"
import script from "./Ihbarname891HacizForm.vue?vue&type=script&lang=ts"
export * from "./Ihbarname891HacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1098d8",
  null
  
)

export default component.exports